import React, { Component } from "react";

export default class Home extends Component {
  render() {

    const { version } = this.props;

    return (
      <div style={{textAlign: 'center'}}>
        <br></br>
        <h1>Defect Dashboard (v{version}) </h1>
        <br></br>
        <p>Welcome to the first release of the Defect Dashboard!</p>
        <br></br>
        <p>Please provide any feedback through Slack to @daniell</p>
        <br></br>
        <p>The source code can be found <a href='https://github.com/MindTouch/Defect-Board' target='_blank' rel='noopener noreferrer'>here</a>.</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/js/pages/Home.js